// Saga for System Module

import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  GET_SYSTEM_MODULE_LIST,
  GET_SYSTEM_MODULE_DATA,
  ACTIVATE_SYSTEM_MODULE,
  DEACTIVATE_SYSTEM_MODULE,
  CREATE_SYSTEM_MODULE,
  UPDATE_SYSTEM_MODULE,
  DELETE_SYSTEM_MODULE,
} from "./actionType";

import {
  getSystemModuleListSuccess,
  getSystemModuleListFail,
  getSystemModuleDataSuccess,
  getSystemModuleDataFail,
  activateSystemModuleSuccess,
  activateSystemModuleFail,
  deactivateSystemModuleSuccess,
  deactivateSystemModuleFail,
  createSystemModuleSuccess,
  createSystemModuleFail,
  updateSystemModuleSuccess,
  updateSystemModuleFail,
  deleteSystemModuleSuccess,
  deleteSystemModuleFail,
} from "./action";

import {
  getSystemModuleListApiCall,
  getSystemModuleDataApiCall,
  activateSystemModuleApiCall,
  deactivateSystemModuleApiCall,
  createSystemModuleApiCall,
  updateSystemModuleApiCall,
  deleteSystemModuleApiCall,
} from "../../helpers/fakebackend_helper";

// List
function* getSystemModuleListSaga() {
  try {
    const response = yield call(getSystemModuleListApiCall);
    yield put(getSystemModuleListSuccess(response));
  } catch (error) {
    yield put(getSystemModuleListFail(error));
  }
}

export function* watchGetSystemModuleListSaga() {
  yield takeEvery(GET_SYSTEM_MODULE_LIST, getSystemModuleListSaga);
}

// Data
function* getSystemModuleDataSaga(action) {
  try {
    const response = yield call(getSystemModuleDataApiCall, action.payload);
    yield put(getSystemModuleDataSuccess(response));
  } catch (error) {
    yield put(getSystemModuleDataFail(error));
  }
}

export function* watchGetSystemModuleDataSaga() {
  yield takeEvery(GET_SYSTEM_MODULE_DATA, getSystemModuleDataSaga);
}

// Activate
function* activateSystemModuleSaga(action) {
  try {
    const response = yield call(activateSystemModuleApiCall, action.payload);
    yield put(activateSystemModuleSuccess(response));
  } catch (error) {
    yield put(activateSystemModuleFail(error));
  }
}

export function* watchActivateSystemModuleSaga() {
  yield takeEvery(ACTIVATE_SYSTEM_MODULE, activateSystemModuleSaga);
}

// Deactivate
function* deactivateSystemModuleSaga(action) {
  try {
    const response = yield call(deactivateSystemModuleApiCall, action.payload);
    yield put(deactivateSystemModuleSuccess(response));
  } catch (error) {
    yield put(deactivateSystemModuleFail(error));
  }
}

export function* watchDeactivateSystemModuleSaga() {
  yield takeEvery(DEACTIVATE_SYSTEM_MODULE, deactivateSystemModuleSaga);
}

// Create
function* createSystemModuleSaga(action) {
  try {
    const response = yield call(createSystemModuleApiCall, action.payload);
    yield put(createSystemModuleSuccess(response));
  } catch (error) {
    yield put(createSystemModuleFail(error));
  }
}

export function* watchCreateSystemModuleSaga() {
  yield takeEvery(CREATE_SYSTEM_MODULE, createSystemModuleSaga);
}

// Update
function* updateSystemModuleSaga(action) {
  try {
    const response = yield call(updateSystemModuleApiCall, action.payload);
    yield put(updateSystemModuleSuccess(response));
  } catch (error) {
    yield put(updateSystemModuleFail(error));
  }
}

export function* watchUpdateSystemModuleSaga() {
  yield takeEvery(UPDATE_SYSTEM_MODULE, updateSystemModuleSaga);
}

// Delete
function* deleteSystemModuleSaga(action) {
  try {
    const response = yield call(deleteSystemModuleApiCall, action.payload);
    yield put(deleteSystemModuleSuccess(response));
  } catch (error) {
    yield put(deleteSystemModuleFail(error));
  }
}

export function* watchDeleteSystemModuleSaga() {
  yield takeEvery(DELETE_SYSTEM_MODULE, deleteSystemModuleSaga);
}

function* SystemModule() {
  yield all([
    watchGetSystemModuleListSaga(),
    watchGetSystemModuleDataSaga(),
    watchActivateSystemModuleSaga(),
    watchDeactivateSystemModuleSaga(),
    watchCreateSystemModuleSaga(),
    watchUpdateSystemModuleSaga(),
    watchDeleteSystemModuleSaga(),
  ]);
}

export default SystemModule;
